import http from "../http-common";
import authHeader from "./authHeader";
import { INQUIRY_TYPE_API } from "../api";
const getAllInquiryTypes = () => {
  return http.get(`${INQUIRY_TYPE_API}`);
};

const createInquiryType = (data) => {
  return http.post(`${INQUIRY_TYPE_API}`, data, { headers: authHeader() });
};

const InquiryTypeService = {
  getAllInquiryTypes,

  createInquiryType,
};

export default InquiryTypeService;
